import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const storage = getStorage(app);
const functions = getFunctions(app);

// if (process.env.NODE_ENV === "development") {
//   console.log("Development mode detected");
//   console.log("Functions URL:", (functions as any)._delegate?._url);
//   console.log("Firestore host:", (db as any)._delegate?._databaseId?.host);

//   // Check if we haven't already connected
//   if (!(functions as any)._delegate?._url?.includes("localhost")) {
//     console.log("Connecting to Functions Emulator");
//     connectFunctionsEmulator(functions, "localhost", 5001);
//   }

//   // Check if Firestore is already connected to emulator
//   if (!(db as any)._delegate?._databaseId?.host?.includes("localhost")) {
//     console.log("Connecting to Firestore Emulator");
//     try {
//       connectFirestoreEmulator(db, "localhost", 8080);
//       console.log("Firestore emulator connection successful");
//     } catch (error) {
//       console.error("Failed to connect to Firestore emulator:", error);
//     }
//   } else {
//     console.log("Firestore already connected to emulator");
//   }
// }

// No Firebase Analytics. GA4 and Google Ads load from GoogleTag in the root
// layout; getAnalytics() would configure the same GA4 ID a second time
// (duplicate page_views) and wrap window.gtag, delaying conversion events.
